import {AxiosError, AxiosResponse} from "axios";
import {Axios} from "../../../axiosHelper";
import {locationActions} from "../../slice/atr/locationSlice";
import {AddLocationRequest, LocationListResponse} from "../../data/location";
import {ResponseBase} from "../../data";

export const getATRLocationList = (page: number, companyId: number): any => {
  return async (dispatch: any) => {
    dispatch(locationActions.setLoading(true));

    Axios.get(`/efe/location/list?page=${page}&size=${100}&companyId=${companyId}`)
      .then((res: AxiosResponse<LocationListResponse>) => {
        dispatch(locationActions.setLocationList(res.data.locations));
        dispatch(locationActions.setLocationCount(res.data.locationCount));


        if (page === 1) {
          dispatch(locationActions.setLocationList(res.data.locations));
        } else {
          dispatch(locationActions.addLocations(res.data.locations));
        }
      })
      .catch((err: AxiosError) => {
        if (err.response) {
          if (err.response.status === 400) {
            const resp: any = err.response.data;
            dispatch(locationActions.setError(resp));
          }
        }
      });
  };
};

export const getATRLocationListAll = (companyId: number): any => {
    return async (dispatch: any) => {
        dispatch(locationActions.setLoading(true));

        Axios.get(`/efe/location/list-all?companyId=${companyId}`)
            .then((res: AxiosResponse<LocationListResponse>) => {
                dispatch(locationActions.setLocationList(res.data.locations));
                dispatch(locationActions.setLocationCount(res.data.locationCount));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(locationActions.setError(resp));
                    }
                }
            });
    };
};

export const addNewLocation = (request: AddLocationRequest): any => {
    return async (dispatch: any) => {
        dispatch(locationActions.setLoading(true));

        Axios.post("/efe/location/new", request, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res: AxiosResponse<ResponseBase>) => {
                dispatch(locationActions.setResponse(res.data));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(locationActions.setError(resp));
                    }
                }
            });
    };
};

export const clearATRCompanyError = (): any => {
  return async (dispatch: any) => {
    dispatch(locationActions.setError(null));
  };
};